<template>
    <div :class="{fullscreen:fullscreen}" class="tinymce-container editor-container">
        <textarea :id="tinymceId" class="tinymce-textarea" style="width:auto;"/>
    </div>
</template>

<script>
    // import tinymce from 'tinymce/tinymce'
    import plugins from './plugins'
    import toolbar from './toolbar'
    import fontFormats from './fontFormats'
    import '../../../../public/tinymce4.7.5/langs/zh_CN'
    // upload image plugins
    import './image'
import { mapGetters } from 'vuex'

    const filterWord = (html) => {
        html = html.replace(/<\/?SPANYES[^>]*>/gi, '')
        html = html.replace(/<\\?\?xml[^>]*>/gi, '')
        return html
    }
    let tinymce = window.tinymce || {}
    export default {
        name: 'Tinymce',
        props: {
            id: {
                type: String,
                default: function () {
                    return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
                }
            },
            value: {
                type: String,
                default: ''
            },
            toolbar: {
                type: Array,
                required: false,
                default() {
                    return []
                }
            },
            menubar: {
                type: String,
                default: 'file edit insert view format table'
            },
            height: {
                type: Number,
                required: false,
                default: 300
            }
        },
        data() {
            return {
                hasChange: false,
                hasInit: false,
                tinymceId: this.id,
                fullscreen: false
            }
        },
        watch: {
            value(val) {
                if (!this.hasChange && this.hasInit) {
                    this.$nextTick(() =>
                        tinymce.get(this.tinymceId).setContent(filterWord(val) || ''))
                }
            },
            language() {
                this.destroyTinymce()
                this.$nextTick(() => this.initTinymce())
            }
        },
        mounted() {
            this.initTinymce()
        },
        activated() {
            this.initTinymce()
        },
        deactivated() {
            this.destroyTinymce()
        },
        destroyed() {
            this.destroyTinymce()
        },
        methods: {
            initTinymce() {
                const _this = this
                tinymce.init({
                    language: 'zh_CN',
                    language_url: '/public/tinymce4.7.5/langs/zh_CN.js',
                    // theme_url: '/static/tinymce4.7.5/theme/modern/theme.min.js',
                    // skin_url: '/static/tinymce4.7.5/skins/skin.min.css',
                    // content_css: '/static/tinymce4.7.5/skins/content.min.css',
                    selector: `#${this.tinymceId}`,
                    height: this.height,
                    object_resizing: false,
                    plugins,
                    toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
                    menubar: false, 
                    paste_data_images: true,
                    images_upload_handler:true,
                    // this.menubar
                    contextmenu: "link inserttable | cell row column deletetable",
                    // end_container_on_empty_block: true,
                    // powerpaste_word_import: 'clean',
                    fontsize_formats: '12px 14px 16px 18px 20px 24px 36px',
                    fullpage_default_font_size: '16px',
                    font_formats: fontFormats,
                    fullpage_default_font_family: 'arial, Chinese Quote;',
                    branding: false,
                    resize: false,
                    init_instance_callback: editor => {
                        if (_this.value) {
                            editor.setContent(filterWord(_this.value))
                        }
                        _this.hasInit = true
                        editor.on('NodeChange Change KeyUp SetContent', () => {
                            _this.hasChange = true
                            _this.$emit('input', filterWord(editor.getContent()))
                        })
                    },
                    setup(editor) {
                        editor.on('FullscreenStateChanged', (e) => {
                            _this.fullscreen = e.state
                        })
                        editor.on("init", () => {
                        _this.loading = false;
                        console.log(_this.value)
                        _this.$emit("on-ready");
                        editor.setContent(_this.value);
                    }),
                        editor.on("input change undo redo", () => {
                        _this.$emit("show", editor.getContent());
                        })
                    },
                    imageSelectorCallback: this.imageUploadCallback
                })
            },
            destroyTinymce() {
                const tinymce1 = tinymce.get(this.tinymceId)
                if (this.fullscreen) {
                    tinymce1.execCommand('mceFullScreen')
                }
                if (tinymce1) {
                    tinymce1.destroy()
                }
            },
            setContent(value) {
                tinymce.get(this.tinymceId).setContent(value)
            },
            getContent() {
                return tinymce.get(this.tinymceId).getContent()
            },
            imageUploadCallback(file, success) {
                console.log(this)
                    const formData = new FormData()
                    formData.append('file', file)
                    this.$axios.post(this.$url.uploadFile, formData,{
                         'Content-Type': 'multipart/form-data'
                    }).then(res => {
                        if(res){
                            success(res.data)
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="less">
    .tiny-container {
        position: relative;
    }

    .tinymce-container {
        // position: relative;
    }

    .tinymce-container ::v-deep .mce-fullscreen {
        z-index: 10000;
    }

    .tinymce-textarea {
        visibility: hidden;
        z-index: -1;
    }
    
</style>
